import { CreateOrUpdateTag } from '../types/tagTypes';

export function createEmptyTag(): CreateOrUpdateTag {
    return {
        stringId: '',
        name: { en: '' },
        synonyms: [],
        parents: [],
        children: [],
        iconMediaId: null,
    };
}
